export default __webpack_public_path__ + "static/media/10gm-gold-coin.1718abd5.svg";